import { ColDef } from '@ag-grid-enterprise/all-modules'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { ICellRendererParams } from '@ag-grid-community/core/dist/cjs/rendering/cellRenderers/iCellRenderer'
import i18n from '@/lang/i18n'

export const shipmentsModalSendGridColumnsDef: ColDef[] = [
    {
        headerName: i18n.tc('shipments.grid.elementNumber'),
        field: 'entityLabel',
        type: AgGridColumnType.TEXT,
        minWidth: 80
    },
    {
        headerName: i18n.tc('shipments.grid.element'),
        field: 'entityType',
        type: AgGridColumnType.SHIPMENT_CORE_ENTITY,
        minWidth: 120
    },
    {
        headerName: i18n.tc('shipments.grid.sampleType'),
        colId: 'sample.sampleType.description',
        field: 'sample.sampleType',
        type: AgGridColumnType.DIACRITICS_INSENSITIVE_TEXT_FOR_CODE_DESCRIPTION_OR_STRING,
        cellRenderer: ({ value }: ICellRendererParams) => value ? `${value.code} | ${value.description}` : '',
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.location'),
        colId: 'sample.topographicCode.description',
        field: 'sample.topographicCode',
        type: AgGridColumnType.DIACRITICS_INSENSITIVE_TEXT_FOR_CODE_DESCRIPTION_OR_STRING,
        cellRenderer: ({ value }: ICellRendererParams) => value ? `${value.code} | ${value.description}` : '',
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.assay'),
        field: 'subportion.assay.name',
        type: AgGridColumnType.TEXT,
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.originStatus'),
        field: 'originStatus',
        type: AgGridColumnType.SHIPMENT_ENTITY_STATUS,
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.destinationStatus'),
        field: 'destinationStatus',
        type: AgGridColumnType.SHIPMENT_ENTITY_STATUS,
        minWidth: 180
    }
]
